import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CHECKOUT_URL, offerChecklist } from '../../data/content';
import { CtaButton } from '../ui/CtaButton';
export function Offer() {
  return <section id="oferta" aria-labelledby="oferta-title" className="w-full bg-ink-850" data-id="element-149" data-mp="307j2a0m3mzx0">
      <div className="mx-auto max-w-2xl px-5 py-16 md:py-20" data-id="element-150" data-mp="356cbhgucs4rd">
        <div className="rounded-3xl border-[3px] border-brand-green bg-ink-card p-7 shadow-panel md:p-10" data-id="element-151" data-mp="357nh7m7czml4">
          <h2 id="oferta-title" className="text-center font-display text-2xl font-black leading-tight text-white md:text-3xl" data-id="element-152" data-mp="3a3clg2ubprnr">
            MÉTODO PARA PADRES DE FUTBOLISTAS
          </h2>
          <p className="mt-3 text-center text-sm font-bold tracking-widest text-brand-gold uppercase" data-id="element-153" data-mp="3nwu2ngzjesam">
            100% DIGITAL · 5 MÓDULOS + 2 BONOS
          </p>
          <ul className="mt-8 space-y-3" data-id="element-154" data-mp="3sxrl7uoglocn">
            {offerChecklist.map(item => <li key={item} className="flex items-start gap-3" data-id="element-155" data-mp="1q5axj78inmt">
                <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-green text-black" data-id="element-156" data-mp="1klzunc6htsma">
                  <CheckIcon className="h-4 w-4" strokeWidth={3} data-id="element-157" data-mp="1bk0bad80acg6" />
                </span>
                <span className="text-[15px] text-body" data-id="element-158" data-mp="16m8izi3g8obg">{item}</span>
              </li>)}
          </ul>
          <div className="mt-8 rounded-2xl bg-ink-950 px-6 py-8 text-center" data-id="element-159" data-mp="23c7u9kazi0xq">
            <p className="text-lg font-semibold text-subtle line-through" data-id="element-160" data-mp="1zamftuisxelf">US$ 87</p>
            <p className="mt-1 font-display text-5xl font-black text-white md:text-6xl" data-id="element-161" data-mp="1ujo12zdgooka">US$ 15</p>
            <span className="mt-4 inline-block rounded-full bg-brand-gold px-4 py-1.5 text-xs font-black uppercase tracking-[0.12em] text-black" data-id="element-162" data-mp="1pkkuvblqwcaq">
              Oferta sólo por hoy
            </span>
            <p className="mt-4 text-xs leading-relaxed text-subtle" data-id="element-163" data-mp="2i98k1i9m7ltk">
              Precio en dólares estadounidenses. Al finalizar su compra, siempre pagará en pesos
              colombianos.
            </p>
          </div>
          <div className="mt-7" data-id="element-164" data-mp="3653hqf59my2u">
            <CtaButton size="xl" fullWidth href={CHECKOUT_URL} data-id="element-165" data-mp="36427udzzkhmp">
              Obtener el método ahora
            </CtaButton>
          </div>
          <p className="mt-5 text-center text-sm text-subtle" data-id="element-166" data-mp="2weqzitkxbgzv">
            🔒 Pago seguro · ⚡ Acceso inmediato · 💳 Pago único · ✅ Garantía 7 días
          </p>
          <p className="mt-2 text-center text-xs text-subtle" data-id="element-167" data-mp="2iden2s4z1xiq">
            Material 100% digital en PDF: no hay envíos ni mensualidades.
          </p>
          <p className="mt-2 text-center text-xs leading-relaxed text-subtle" data-id="element-168" data-mp="29ekvjg6hzxc1">
            Este material es educativo y no reemplaza la asesoría de un abogado especializado en
            derecho deportivo.
          </p>
        </div>
      </div>
    </section>;
}